export function startWithUpperCase(text) {
  if (typeof text === 'string') {
    return text?.toLowerCase()?.replace(/(?:^|\s)\S/g, function (a) {
      return a?.toUpperCase();
    });
  } else {
    return text;
  }
}
